module.exports = __webpack_public_path__ + "static/media/pescadosymariscos.ed216f47.svg";